export const LOCALES = ["en", "vi"] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";
export const LOCALE_COOKIE = "vivoo_locale";

export function isLocale(value: string | undefined | null): value is Locale {
  return value === "en" || value === "vi";
}

export function normalizeLocale(value: string | undefined | null): Locale {
  return isLocale(value) ? value : DEFAULT_LOCALE;
}

export function getTranslationTargetLocale(value: string | undefined | null): Locale {
  return normalizeLocale(value) === "en" ? "vi" : "en";
}
